module.exports = {
	"meta": {
		"title": [
			"{photoStyle}",
			"{photoRoom}",
			"in {projectLocation}",
			"by {firmName}"
		]
	},
	"socialSharing": {
		"facebook": {
			"title": "Featured Project: {firmName}",
			"description": "Tour a {projectName} on 1stdibs"
		},
		"email": {
			"subject": "Design Inspiration on 1stdibs",
			"body": "Check out {firmName}'s {projectName} project on 1stdibs. {url}"
		},
		"pinterest": {
			"description": "See more of {firmName}'s {projectName} on 1stdibs"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./json/copy/photoGallery.json
// module id = 1014
// module chunks = 4 22 26 29